
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CyberSpaceEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(12 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const z = ((i / count) + curTime * 0.2) % 1;
                const s = (1 - z) * 1000 * scale;
                const alpha = z * 0.5;
                
                ctx.save();
                ctx.globalAlpha = alpha / layerIndex;
                ctx.lineWidth = (1 + (1 - z) * 5) * scale;
                ctx.strokeRect(-s/2, -s/2, s, s);
                
                // Connecting corners to center for tunnel effect
                ctx.beginPath();
                ctx.moveTo(-s/2, -s/2); ctx.lineTo(0, 0);
                ctx.moveTo(s/2, -s/2); ctx.lineTo(0, 0);
                ctx.moveTo(-s/2, s/2); ctx.lineTo(0, 0);
                ctx.moveTo(s/2, s/2); ctx.lineTo(0, 0);
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
